import { Typography } from '@mui/material';
import { GeoEventBaseChangelog } from 'features/geoEvents/components/GeoEventChangelog';
import {
  isFloodingGeoEvent,
  isWildfireGeoEvent,
} from 'features/geoEvents/geoEvent.utils';
import { useWildfireProgressFormFieldChanges } from 'features/wildfires/hooks/useWildfireProgressFormFieldChanges';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { EvacZone, RegionEvacZoneStyle } from 'shared/types';
import { ReportableGeoEvent } from './types';

type ReportGeoEventChangelogProps = {
  geoEvent: ReportableGeoEvent;
  evacZones: EvacZone[];
  zoneStyle: RegionEvacZoneStyle;
  title?: string;
  hideConfirmations?: boolean;
};

const ReportWildfireChangelog = (
  props: ReportGeoEventChangelogProps & { geoEvent: Wildfire },
): JSX.Element => {
  const {
    geoEvent: wildfire,
    evacZones,
    zoneStyle,
    title,
    hideConfirmations,
  } = props;
  const progressChanges = useWildfireProgressFormFieldChanges({
    wildfire,
  });

  return (
    <GeoEventBaseChangelog
      geoEvent={wildfire}
      evacZones={evacZones}
      zoneStyle={zoneStyle}
      title={title}
      hideConfirmations={hideConfirmations}
    >
      {Object.values(progressChanges).map((change) => (
        <Typography key={change}>{change}</Typography>
      ))}
    </GeoEventBaseChangelog>
  );
};

export const ReportGeoEventChangelog = (
  props: ReportGeoEventChangelogProps,
): JSX.Element | null => {
  const { geoEvent, evacZones, zoneStyle, title, hideConfirmations } = props;

  if (isWildfireGeoEvent(geoEvent)) {
    return (
      <ReportWildfireChangelog
        geoEvent={geoEvent}
        evacZones={evacZones}
        zoneStyle={zoneStyle}
        title={title}
        hideConfirmations={hideConfirmations}
      />
    );
  }

  if (isFloodingGeoEvent(geoEvent)) {
    return (
      <GeoEventBaseChangelog
        geoEvent={geoEvent}
        evacZones={evacZones}
        zoneStyle={zoneStyle}
        title={title}
        hideConfirmations={hideConfirmations}
      />
    );
  }

  return null;
};
